import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getBlockDate} from 'utils/getBlockDate.js';
import {useScroll} from './useScroll.js';
import SourceResults from './SourceResults.js';
import {connect} from 'react-redux';
import {formatDate} from './formatDate.js';

const DayResults = ({setPackToSearch, day, sequencerEngine, showPianoRoll, bottomHeight, currentSoundInList}) => { 
    let {discogs, blockNumber, youtube, unsourced} = day;
    let [date, setDate] = useState(undefined);

    useEffect(() => {
        getBlockDate(blockNumber).then(
            setDate);
    }, [blockNumber]);
    
    let ref = useRef(undefined);

    let {size} = useScroll(ref, (window.innerHeight / 770.0) * 30, true, undefined, undefined, undefined, undefined, currentSoundInList);

    let unsourcedResults = [];
    for (let tag in unsourced) {
        unsourcedResults = [... unsourcedResults, ... unsourced[tag]];
    }
    let i=0;
    let resultsCount = 0;
    let list = [];
    for (let coverArtHash in discogs) {
        let resultsSize = size - resultsCount;
        if (coverArtHash === undefined || coverArtHash === '') {
            console.log("EMPTY COOVER");
        }
        if (resultsSize > 0) {
            list.push(
                <SourceResults
                  odd={++i % 2 === 0}
                  key={i}
                  resultsCounter={resultsCount}
                  setPackToSearch={setPackToSearch}
                  scrollRef={ref}
                  resultsSize={resultsSize}
                  sequencerEngine={sequencerEngine}
                  source={{results: discogs[coverArtHash], coverArtHash}}
                />);
            resultsCount += Math.min(resultsSize, discogs[coverArtHash].length);
        }
    }
    for (let videoId in youtube) {
        let resultsSize = size - resultsCount;
        if (resultsSize > 0) {
            list.push(
                <SourceResults
                  odd={++i % 2 === 0}
                  key={i}
                  scrollRef={ref}
                  setPackToSearch={setPackToSearch}
                  resultsCounter={resultsCount}
                  resultsSize={resultsSize}
                  sequencerEngine={sequencerEngine}
                  source={{results: youtube[videoId], videoId}}
                />);
            resultsCount += Math.min(resultsSize, youtube[videoId].length);
        }
    }

    let resultsSize = size - resultsCount;
    for (let tag in unsourced) {
        let resultsSize = size - resultsCount;
        if (resultsSize > 0) {
            list.push(
                <SourceResults
                  odd={++i % 2 === 0}
                  key={i}
                  setPackToSearch={setPackToSearch}
                  scrollRef={ref}
                  resultsSize={resultsSize}
                  isUnsourced={true}
                  resultsCounter={resultsCount}
                  sequencerEngine={sequencerEngine}
                  source={{results: unsourced[tag], tag: tag}}/>);
            resultsCount += Math.min(resultsSize, unsourced[tag].length);
        }
    }

    let style = {
        height: window.innerHeight - 222
    };
    return (
        <div style={style} ref={ref} className="day-results">
          <div className="date">
            {list}
          </div>
        </div>);
}

const addToList = (map) => {
    let list = [];
    for (let key in map) {
    }
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight,
      currentSoundInList: state.selector.currentSoundInList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DayResults);
